import {Box} from '@mui/material';
import {Workspace} from '../../pages/user-management/models';
import styles from '../../../styles/components/userManagement/clientInfoTab.module.scss';
import {Permission} from '../../../types/permission-group/permission';

type StackedWorkspacesProps = {
  headerText?: string;
  workspaces: Workspace[];
  projectPermissions?: Permission[];
  isAboveBadge?: boolean;
};

const StackedWorkspaces = ({
  headerText,
  workspaces,
}: StackedWorkspacesProps) => {
  if (workspaces.length == 0) return null; // Prevent rendering if we have no workspaces

  return (
    <Box>
      {headerText && (
        <Box className={`${styles.workspaceContainerHeader}`}>{headerText}</Box>
      )}
      {
        <Box className={`${styles.workspaceContainerBody}`}>
          {workspaces.map((item) => {
            return (
              <Box
                className={`${styles.workspaceContainer}`}
                key={item.workspaceCode}
              >
                {`${item.workspaceCode} - ${item.workspaceName}`}
              </Box>
            );
          })}
        </Box>
      }
    </Box>
  );
};

export default StackedWorkspaces;
